export default __webpack_public_path__ + "static/media/sambinoreal.873e3a42.jpg";